import { queryOptions, useQuery } from '@tanstack/react-query';

import { getPromoGroupHighlights } from '../queries/promos';
import { useAuthStore, useShipToStore } from '../stores';

export const PROMO_GROUP_HIGHLIGHTS_QUERY_KEY = 'PromoGroupHighlights';

export function getPromoGroupHighlightsOptions(
  access_token: string,
  warehouse: string,
  enabled = false
) {
  return queryOptions({
    queryKey: [PROMO_GROUP_HIGHLIGHTS_QUERY_KEY],
    queryFn: () => getPromoGroupHighlights(access_token, warehouse),
    retry: false,
    enabled: !!warehouse && enabled,
    staleTime: 1000 * 60 * 4,
  });
}

export const useGetPromoGroupHighlights = ({ enabled = false }) => {
  const session = useAuthStore();
  const { selectedShipToId } = useShipToStore();

  return useQuery(
    getPromoGroupHighlightsOptions(
      session.access_token,
      selectedShipToId,
      enabled
    )
  );
};
